<div >
  <div class="progress-steps">
    <span id="currentStep"><b>Step {{currentStep}}:</b> {{stepName}}</span>
    <span id="nextStep"><b>Next: </b>{{nextStepName}}</span>
  </div>
  <!-- <p-progressBar [value]="progress" ></p-progressBar>-->
  <mat-progress-bar [value]="progress"></mat-progress-bar>
</div>
  